<template>
    <div class="contact-form">
        <form v-if="! loading && ! sended" method="POST">
            <div class="columns">
                <div class="column is-4">
                    <input-field :errors="errors" type="text" v-model="input.firstName" name="firstName" :label="$t('contact.form.firstName')"></input-field>
                </div>
                <div class="column is-4">
                    <input-field :errors="errors" type="text" v-model="input.lastName" name="lastName" :label="$t('contact.form.lastName')"></input-field>
                </div>
                <div class="column is-4">
                    <input-field :errors="errors" type="email" v-model="input.email" name="email" :label="$t('contact.form.email')"></input-field>
                </div>
            </div>
            <textarea-field :errors="errors" v-model="input.body" name="body" :label="$t('contact.form.message')"></textarea-field>
            <privacy-policy :errors="errors" v-model="input.policy" name="policy"
            :link="policyLink" :label="$t('contact.form.privacyPolicy')"></privacy-policy>
            <div class="has-text-centered">
                <button @click.prevent="submit" class="button" v-t="'contact.form.cta'"></button>
            </div>
        </form>
        <div v-if="loading && ! sended" class="loading has-text-centered">
            <i class="fas fa-circle-notch fa-5x fa-spin"></i>
        </div>
        <div v-if="! loading && sended" class="content has-text-centered">
            <p><strong v-t="'contact.form.feedback.title'"></strong></p>
            <p v-t="'contact.form.feedback.message'"></p>
        </div>
    </div>
</template>
<script>
    import InputField from './InputField'
    import TextareaField from './TextareaField'
    import PrivacyPolicy from './PrivacyPolicy'
    import axios from 'axios'
    import FormErrors from './../Classes/FormErrors'

    export default {
        components: {
            InputField,
            TextareaField,
            PrivacyPolicy
        },
        data() {
            return {
                input: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    body: '',
                    policy: null
                },
                loading: false,
                sended: false,
                errors: new FormErrors()
            }
        },
        methods: {
            submit() {
                this.loading = true
                axios.post( location.origin+'/includes/mailer/index.php', this.input )
                    .then( response => {
                        this.loading = false
                        this.sended = true
                    })
                    .catch( error => {
                        this.loading = false
                        this.errors.record( error.response.data.errors )
                    } )
            }
        },
        computed: {
            policyLink() {
                return ( this.$i18n.locale === 'it' ) ? 'https://www.iubenda.com/privacy-policy/28037983' : 'https://www.iubenda.com/privacy-policy/44187315'
            }
        }
    }
</script>